import React from 'react'

import LeaderBoardDropDown from './LeaderBoardDropDown'
import FeedFilterByRange from './FeedFilterByRange'
import './styles.scss'

const bc = 'feed-filter'

const FeedFilter = () => (
  <div className={bc}>
    <FeedFilterByRange />
    <LeaderBoardDropDown />
  </div>
)

export default FeedFilter
